import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import AdminTransactionIndex from "../../../../components/SidetabPages/Transaction/AdminTransaction/AdminTransactionIndex";

const AdminTransaction = () => {
  return (
    <>
      <AnnouncementBar />
      <AdminTransactionIndex />
    </>
  );
};
export default AdminTransaction;
